import React, { useCallback, useEffect, useState } from "react";
import { colorWhite } from "../../../utility/constants/colorManager";
import { NeokredNewLogo } from "../../../utility/constants/assetsManager";
import ResizeListner from "../../../utility/ResizeListner";
import secureStorage from "../../../services/secureStorage";
import { SS_WHITELISTED_LOGO } from "../../../utility/constants/secureStorageManager";
import { useSelector } from "react-redux";

const ImageComponent = () => {
  const { width } = ResizeListner();
  const [imageLogo, setImageLogo] = useState("");
  const reduxLogo = useSelector((state) => state.logoSlice);
  const logo = secureStorage.getItem(SS_WHITELISTED_LOGO);

  useEffect(() => {
    if (reduxLogo?.logo) {
      setImageLogo(reduxLogo?.logo);
    }
  }, [reduxLogo]);

  return (
    <div
      style={{
        width: width > 650 ? "50%" : "100%",
        display: width > 650 ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: colorWhite,
      }}
    >
      <img
        src={imageLogo ? imageLogo : NeokredNewLogo}
        style={{
          width: width * 0.35,
          minWidth: 150,
          maxWidth: 400,
        }}
      />
    </div>
  );
};

export default ImageComponent;
